// ----------------------------------------------------------------------------
// Template: Account
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/rivo/rivo-sms';

// Styles
import './_account.scss';
import './_recharge-account.scss';

const LOG_OUT_BUTTON   = '.button__log-out';

document.addEventListener('DOMContentLoaded', function() {
    const logOutButton = document.querySelector(LOG_OUT_BUTTON);

    if(logOutButton) {
        logOutButton.addEventListener('click', (event) => {
            dataLayer.push({'event': 'sign_out'});
        });
    }
});
